<template>
  <v-container v-if="skip && !loadedAll && !mostrarPopUpSincronizacion">
    <o-main-progress/>
  </v-container>
  <page-layout v-else
    :breadcrumbs="breadcrumbs"
    :title="$t('pages.reservas.detalleReserva')" 
  >
    <o-main-progress v-if="!loadedAll"/>
    <v-card v-else>
      <v-img
        :src="imagenPromocion"
        height="200px"
      />
      <v-container fluid v-if="loadedAll">
        <o-big-title justify="start" align="left" :divider="false">{{promocion.descripcion}} - {{inmueble.descripcionLarga}}</o-big-title>
        <o-big-title justify="end" align="right">{{totalImporte | currency}}</o-big-title>
        <o-base-justify-text v-html="textoPasoActual"></o-base-justify-text>
        <v-layout v-for="card in tarjetasReserva" :key="card.id" mb-3>
          <v-flex xs12>
            <ReservaCard :id="card.id"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-fade-transition>
      <custom-dialog v-if="mostrarPopUpSincronizacion" v-model="mostrarPopUpSincronizacion" :noCerrar="true">
        <PopUpSincronizacion
          @hide="cerrarPopUpSincronizacion()"
          :reservaId="id"
          :error="errorSincronizacion"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog v-if="mailNoConfirmado" v-model="mailNoConfirmado" :noCerrar="true">
        <PopUpConfirmacion :incrustado="false" @volver="volverInicio"/>
      </custom-dialog>
    </v-fade-transition>
  </page-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ReservaCard from '@/components/reservas/ReservaCard'
import MixinReserva from '@/mixins/reserva'
import PopUpSincronizacion from '@/components/generic/PopUpSincronizacion'
import PopUpConfirmacion from '@/components/generic/PopUpConfirmacion'
import modulos from '@/mixins/modulos'

export default {
  mixins: [MixinReserva, modulos],
  props: {
    id: {
      required: true
    },
    skip: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadedAll: false,
      mostrarPopUpSincronizacion: false,
      mailNoConfirmado: false,
      loading: false,
      emailEnviado: 0,
      errorSincronizacion: '',
      sincronizando: false
    }
  },
  components: {
    ReservaCard,
    PopUpConfirmacion,
    PopUpSincronizacion
  },
  async created () {
    try {
      await this.loadReserva(this.id)
      if (!this.reserva.sincronizada) {
        this.sincronizando = true
        await this.sincronizarReserva(this.id)
        this.sincronizando = false
      }
      this.mailNoConfirmado = (this.reserva.actorConfirmacion === null || this.reserva.actorConfirmacion.token != null)
      if (this.skip && this.reserva.sincronizada && !this.mailNoConfirmado) {
        // Ir al siguiente paso si se puede
        let moduloActual = this.modulos.find(x => this.getModuloEstado(x.tipo, this.reserva) !== 'aceptada')
        if (moduloActual != null) {
          if (moduloActual.tipo === 'kyc' && this.getModuloCodigo('kyc', this.reserva) === 3) {
            // Si el KYC esta en estado 3 Rellenado hay que llevar a documentacion
            moduloActual = this.modulos.find(x => x.tipo === 'documentacion')
          }
          if (this.comprobarEstadoActual(moduloActual.tipo, this.reserva)) {
            this.$router.push({name: 'reservas.id.' + moduloActual.tipo, params: {id: this.reserva.id}})
            return
          }
        }
      }
      this.loadedAll = true
    } catch (error) {
      console.error(error)
      // flag metida para que cuando la reserva esté intentando sincronizar y pete no te mande a reservas
      if (!this.sincronizando) {
        this.$router.push({name: 'reservas.list'})
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      } else {
        this.errorSincronizacion = error.message
        this.mostrarPopUpSincronizacion = true
      }
    }
  },
  computed: {
    ...mapGetters({
      inmueble: 'promociones/inmuebles/getActual',
      promocion: 'promociones/getActual',
      tarifa: 'reservas/_id/tarifas/getActual',
      getCards: 'reservas/getCards',
      reserva: 'reservas/_id/getActual'
    }),
    descripcionPopUp () {
      switch (this.emailEnviado) {
        case 0:
          return (this.esAdministrador || this.esPbc || this.esComercial) ? this.$t('pages.reservas.activarCuenta') : this.$t('pages.reservas.noHaActivado')
        case 1:
          return (this.esAdministrador || this.esPbc || this.esComercial) ? this.$t('pages.reservas.correoReenviado') : this.$t('pages.reservas.correoReenviadoConfirmacion')
        case 2:
          return this.$t('pages.reservas.errorEnvio')
      }
      return null
    },
    breadcrumbs () {
      if (this.esAdministrador) {
        return [
          {
            text: this.$t('pages.home'),
            exact: true,
            to: {name: 'home'}
          },
          {
            text: this.$t('pages.reservas.reservas'),
            exact: true,
            to: {name: 'reservas.list'}
          },
          {
            text: this.$t('pages.reservas.detalleReserva'),
            disabled: true
          }
        ]
      } else {
        return [
          {
            text: this.$t('pages.reservas.reservas'),
            exact: true,
            to: {name: 'reservas.list'}
          },
          {
            text: this.$t('pages.reservas.detalleReserva'),
            disabled: true
          }
        ]
      }
    },
    totalImporte () {
      return this.tarifa.importeTotalConHijos
    },
    imagenPromocion () {
      if (this.promocion.documentoImagen.length > 0) {
        return this.$apiDocument(this.promocion.documentoImagen[0].documento)
      }
      return require('@/assets/images/vivienda.jpg')
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadReserva: 'reservas/_id/load',
      sincronizarReserva: 'reservas/sincronizarReserva'
    }),
    volverInicio () {
      this.mailNoConfirmado = false
      this.$router.push({name: 'reservas.list'})
    },
    cerrarPopUpSincronizacion () {
      this.loadedAll = true
      this.mostrarPopUpSincronizacion = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reservas/_id.vue